import { useEffect, useState } from 'react';

const useClientSideRender = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
};

export { useClientSideRender };
